import React from "react";
import PropTypes from "prop-types";
import injectSheet from "react-jss";
import { Typography } from "@material-ui/core";

import { Flex } from "../../../../../_common";

const style = () => ({
  containerComObservacao: {
    width: "100%",
    border: "1px solid rgba(0, 0, 0, 0.23)",
    padding: 24,
    borderRadius: 8,
    marginBottom: 12,
  },
  tituloLead: {
    marginBottom: 8,
  },
});

function ObservacoesAtividades({ atividade, isAtividadeEmMassa, classes }) {
  return (
    <>
      <Flex flexDirection="column" className={classes.containerComObservacao}>
        {isAtividadeEmMassa && (
          <Typography variant="h5" className={classes.tituloLead}>
            {atividade.lead?.nome}
          </Typography>
        )}
        <Typography variant="body1">{atividade?.observacoes}</Typography>
      </Flex>
    </>
  );
}

ObservacoesAtividades.propTypes = {
  atividade: PropTypes.object,
  isAtividadeEmMassa: PropTypes.bool,
};

export default injectSheet(style)(ObservacoesAtividades);
